import React from 'react'
import styled from 'styled-components'
import { ThemeToggler } from 'gatsby-plugin-dark-mode'

const Switch = styled.label`
    display: flex;
    height: 36px;
    position: relative;
    width: 70px;
    margin-bottom: 0;
`;

const Slider = styled.div`
    background-color: #FFF;
    border:1px solid #000;
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: .4s;
    border-radius: 34px;

    ::before {
        background-color: #333;
        border:1px solid #000;
        bottom: 3px;
        content: "";
        height: 26px;
        left: 4px;
        position: absolute;
        transition: .4s;
        width: 26px;
        z-index:421;
        border-radius: 50%;
    }
`;

const Input = styled.input.attrs(props => ({
    type: "checkbox",
}))`
    display: none;

    :checked + .slider {
        background-color: #101211;
    }

    :checked + .slider:before {
        transform: translateX(34px);
        border-color:#CFCFCF;
        background-color:#EFEFEF;
      }
`;

const spanStyle = {
    'width': '50%',
    'textAlign': 'center',
    'padding': '0.25em',
    'position': 'relative',
    'zIndex': '420',
}


export default function Toogler() {

    return (
        <ThemeToggler>
            {({ theme, toggleTheme }) => (
                <div className="wrapper">
                    <Switch htmlFor="checkbox">
                        <Input id="checkbox"
                            onChange={e => toggleTheme(e.target.checked ? 'dark' : 'light')}
                            checked={theme === 'dark'} />
                        <Slider className="slider" />
                        <span role="img" aria-labelledby="Moon" aria-label="Moon"
                            style={spanStyle}>🌙</span>
                        <span role="img" aria-labelledby="Sun" aria-label="Sun"
                            style={spanStyle}>☀️</span>
                    </Switch>
                </div>
            )}
        </ThemeToggler>
    )
}